var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vip-regular"},[_c('img',{staticStyle:{"width":"80%"},attrs:{"src":require("../../../assets/img/invest/vip.png"),"alt":"   "}})])
}]

export { render, staticRenderFns }